<template>
  <i18nLink
    :class="$style.root"
    :to="{
      name: 'program-slug',
      params: {
        slug: slug
      }
    }"
  >
    <CoreImageComponent
      v-if="localizedData?.cover_image?.data?.attributes"
      :image="localizedData?.cover_image?.data?.attributes"
      :class="$style.image"
    />

    <div :class="$style.info">
      <div>
        <div>
          {{ title }}
        </div>

      </div>

      <div>
        <div v-if="status" :class="$style.tag">{{ status }}</div>
        <CoreDateTimeRangeComponent
          :class="$style.dateTimeRange"
          v-for="range in localizedData?.date_time_ranges"
          :key="range?.id"
          :dateStart="range?.date_time_start"
          :dateEnd="range?.date_time_end"
        />
      </div>
    </div>
  </i18nLink>
</template>

<script setup>
const props = defineProps({
  data: Object
})

const localizedData = computed(() => {
    return i18nGetLocalizedData(baseStrapiGetAttributes(props?.data))
})

const title = computed(() => {
  return localizedData?.value?.titles?.current_locale || localizedData?.value?.titles?.i18n_title_en
})

const slug = computed(() => {
  return localizedData?.value?.slugs?.current_locale || localizedData?.value?.slugs?.i18n_slug_en
})

const status = props?.forcePastStatus ? 'past' : getItemProgramStatus(props?.data)

const introduction = computed(() => {
  return baseTruncateString(localizedData?.value?.introductions?.current_locale || localizedData?.value?.introductions?.i18n_richtext_en, 20)
})
</script>

<style module lang="scss">
.root {
  display: grid;
  grid-template-columns: .25fr 1fr;
  gap: var(--unit--horizontal);
}

.root:hover  {
  color: var(--color--accent);
}

.info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tag {
  text-transform: uppercase;
}
</style>
